import React, { useState } from "react";
import { signUp } from "../services/api";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const SignupForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    role: "user", // default role
  });

    const { signup } = useAuth();
  
    const navigate = useNavigate();

  const [errors, setErrors] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      setErrors("Passwords do not match");
      return;
    }

    try {
      setErrors("");
      setSuccess("");

      const payload = {
        username: formData.email, // using email as username
        name: formData.name,
        email: formData.email,
        password: formData.password,
        role: formData.role,
      };

      const res = await signup(payload);
        navigate("/");

      if (res && res.token) {
        setSuccess("User registered successfully!");
        // Optionally store token or redirect here
      } else {
        setErrors(res.message || "Signup failed");
      }
    } catch (err) {
      console.error(err);
      setErrors("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="main-bg">
      <div className="container">
        <div className="row justify-content-center mt-5">
          <div className="col-lg-5 col-md-6 col-sm-6">
            <div className="card shadow">
              <div className="card-title text-center border-bottom">
                <h2 className="p-3">Sign Up</h2>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="phone" className="form-label">
                      Phone
                    </label>
                    <input
                      type="tel"
                      className="form-control"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="role" className="form-label">
                      Role
                    </label>
                    <select
                      className="form-control"
                      id="role"
                      name="role"
                      value={formData.role}
                      onChange={handleChange}
                    >
                      <option value="user">User</option>
                      <option value="admin">Admin</option>
                      <option value="manager">Manager</option>
                    </select>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">
                      Password
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      id="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="confirmPassword" className="form-label">
                      Confirm Password
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      id="confirmPassword"
                      name="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  {errors && <div className="alert alert-danger">{errors}</div>}
                  {success && (
                    <div className="alert alert-success">{success}</div>
                  )}
                  <div className="d-grid">
                    <button
                      type="submit"
                      className="btn btn-primary text-light main-bg"
                    >
                      Sign Up
                    </button>
                  </div>
                </form>

                <div className="text-center mt-3">
                  <span>Already have an account? </span>
                  <Link
                    to="/login"
                    className="text-primary"
                    style={{ textDecoration: "none" }}
                  >
                    Login
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupForm;
